import { render, staticRenderFns } from "./dictlist.vue?vue&type=template&id=7bfb95f1&scoped=true"
import script from "./dictlist.vue?vue&type=script&lang=js"
export * from "./dictlist.vue?vue&type=script&lang=js"
import style0 from "./dictlist.vue?vue&type=style&index=0&id=7bfb95f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfb95f1",
  null
  
)

export default component.exports